import React, {
  ReactElement, useEffect, useRef, useState,
} from 'react';
import { animated, useSpring } from 'react-spring';
import cs from 'classnames';
import { Logo } from '../../ui/logo';

import style from './style.module.scss';
import { Typography, TypographyVariants } from '../../ui/typography';

export const PreviewSection = (): ReactElement => {
  const [scrollableFirstText, setScrollableFirstText] = useState(false);
  const [scrollableSecondText, setScrollableSecondText] = useState(false);
  const [scrollableThirdText, setScrollableThirdText] = useState(false);
  const firstRender = useRef(true);

  const stylesTextFirst = useSpring({
    from: { y: scrollableFirstText && !firstRender.current ? '0%' : '200%', opacity: scrollableFirstText && !firstRender.current ? 1 : 0, scale: scrollableFirstText && !firstRender.current ? 1 : 1.5 }, to: { y: !scrollableFirstText && !firstRender.current ? '-100%' : '0%', opacity: (scrollableSecondText || !scrollableFirstText) && !firstRender.current ? 0 : 1, scale: 1 }, config: { duration: 500 },
  });

  const stylesTextSecond = useSpring({ opacity: scrollableSecondText ? 1 : 0, y: scrollableSecondText ? '-100%' : '0%' });
  const stylesTextThird = useSpring({ opacity: scrollableThirdText ? 1 : 0, y: scrollableThirdText ? '-100%' : '0%' });

  useEffect(() => {
    const onScroll = (): void => {
      setScrollableFirstText(window.scrollY < 20);
      setScrollableSecondText(window.scrollY > 20 && window.scrollY < 140);
      setScrollableThirdText(window.scrollY > 140);
    };

    firstRender.current = false;

    document.addEventListener('scroll', onScroll);

    return () => document.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section className={style.section}>
      <Logo />
      <div className={style.textContainer}>
        <animated.span style={stylesTextFirst} className={style.text}>
          Все, что вы
          <Typography highlight variant={TypographyVariants.pLargeX} component="span"> любите</Typography>
        </animated.span>
        <animated.span style={stylesTextSecond} className={style.text}>
          С теми, кого вы
          <Typography variant={TypographyVariants.pLargeXL} highlight component="span"> цените</Typography>
        </animated.span>
        <animated.span style={stylesTextThird} className={style.text}>
          <Typography variant={TypographyVariants.pLargeXL} highlight component="span">Наслаждайтесь</Typography>
          {'\n совместным просмотром'}
        </animated.span>
      </div>
    </section>
  );
};
